"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _simpleCustomErrors = _interopRequireDefault(require("simple-custom-errors"));

var _core = _interopRequireDefault(require("./core"));

var _request2 = _interopRequireWildcard(require("./request"));

var _qs = _interopRequireDefault(require("qs"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HTTP = /*#__PURE__*/function () {
  function HTTP() {
    _classCallCheck(this, HTTP);
  }

  _createClass(HTTP, null, [{
    key: "install",
    value: function install(Vue) {
      Vue.prototype.$http = this;
    }
  }, {
    key: "refreshTokenset",
    value: function () {
      var _refreshTokenset = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.refreshTokensetPromise) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this.refreshTokensetPromise);

              case 2:
                // If it wasn't set yet, set it now
                this.refreshTokensetPromise = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var _yield$_this$post, data;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return _this.post('/auth/refreshtoken', {
                            body: {
                              refreshtoken: _core["default"].auth.refreshtoken
                            }
                          }, {
                            skipAuth: true
                          });

                        case 3:
                          _yield$_this$post = _context.sent;
                          data = _yield$_this$post.data;

                          _core["default"].auth.saveCredentials(data);

                        case 6:
                          _context.prev = 6;
                          _this.refreshTokensetPromise = null;
                          return _context.finish(6);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0,, 6, 9]]);
                }))();
                return _context2.abrupt("return", this.refreshTokensetPromise);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshTokenset() {
        return _refreshTokenset.apply(this, arguments);
      }

      return refreshTokenset;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(method, url) {
        var data,
            options,
            request,
            response,
            _error,
            error,
            filename,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                options = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                // Create data
                if (!data.body) data.body = {};
                if (!data.headers) data.headers = {};
                if (!data.query) data.query = {};
                data.headers = _objectSpread(_objectSpread({}, data.headers), _request2["default"].defaultHeaders(_objectSpread({}, options))); // beforeRequest hook

                _context3.next = 8;
                return _request2["default"].__beforeRequest(method, url, data, options);

              case 8:
                // Add query to url, if necessary
                if (data.query && Object.keys(data.query).length) {
                  url = "".concat(url, "?").concat(_qs["default"].stringify(data.query, {
                    encode: false
                  }));
                }

                request = _objectSpread({
                  baseURL: this.uri,
                  method: method,
                  url: url,
                  data: data.body,
                  headers: data.headers || {}
                }, options || {}); // Add responseType to request if set

                if (options && options.responseType) {
                  request.responseType = options.responseType;
                }

                response = null;
                _context3.prev = 12;
                _context3.next = 15;
                return _axios["default"].request(request);

              case 15:
                response = _context3.sent;
                _context3.next = 41;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](12);

                if (!_context3.t0.response) {
                  _context3.next = 38;
                  break;
                }

                if (!(_context3.t0.response.data && _context3.t0.response.data.error === 'Unauthorized')) {
                  _context3.next = 34;
                  break;
                }

                if (!(_core["default"].auth.refreshToken && options.skipAuth !== true)) {
                  _context3.next = 33;
                  break;
                }

                _context3.prev = 23;
                _context3.next = 26;
                return HTTP.refreshTokenset();

              case 26:
                _context3.next = 32;
                break;

              case 28:
                _context3.prev = 28;
                _context3.t1 = _context3["catch"](23);

                // If 404, logout because refreshtoken is not found
                if (_context3.t1.code === 404) {
                  _core["default"].auth.logout();
                }

                throw _context3.t1;

              case 32:
                return _context3.abrupt("return", this.request(method, url, data, options));

              case 33:
                // If no refreshtoken is found, just log out
                _core["default"].auth.logout();

              case 34:
                // Error from API
                _error = new _request2.RequestError('ApiError', {
                  code: _context3.t0.response.data.code || _context3.t0.response.status,
                  error: _context3.t0.response.data.error,
                  message: _context3.t0.response.data.message,
                  transport: 'http',
                  response: _context3.t0.response.data,
                  request: request
                }); // Change http.statusCode according to response

                _error.http.statusCode = _context3.t0.response.status; // Improve stack trace (https://github.com/axios/axios/issues/2387)

                _error.stack = _error.stack.split('\n').slice(0, 2).join('\n') + '\n' + _context3.t0.stack;
                throw _error;

              case 38:
                // If not, it's an error in the request
                error = new this.RequestErrors('RequestError', {
                  request: request,
                  code: _context3.t0.code,
                  errno: _context3.t0.errno,
                  syscall: _context3.t0.syscall,
                  address: _context3.t0.address,
                  port: _context3.t0.port,
                  config: _context3.t0.config
                }); // Improve stack trace (https://github.com/axios/axios/issues/2387)

                error.stack = error.stack.split('\n').slice(0, 2).join('\n') + '\n' + _context3.t0.stack;
                throw error;

              case 41:
                // Check if file has to be downloaded
                if (options.skipDownload !== true && response.headers['content-disposition'] && response.headers['content-disposition'].includes('attachment;')) {
                  filename = response.headers['content-disposition'].split('filename=')[1];
                  this.downloadFile(filename, response.data, response.headers['content-type']);
                }

                return _context3.abrupt("return", response);

              case 43:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[12, 18], [23, 28]]);
      }));

      function request(_x, _x2) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "get",
    value: function get() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.request.apply(this, ['get'].concat(args));
    }
  }, {
    key: "post",
    value: function post() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.request.apply(this, ['post'].concat(args));
    }
  }, {
    key: "put",
    value: function put() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.request.apply(this, ['put'].concat(args));
    }
  }, {
    key: "patch",
    value: function patch() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.request.apply(this, ['patch'].concat(args));
    }
  }, {
    key: "delete",
    value: function _delete() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return this.request.apply(this, ['delete'].concat(args));
    }
  }, {
    key: "downloadFile",
    value: function downloadFile() {
      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!filename && !content) {
        return;
      } // Check if document (HTML page) is found


      if (!document) {
        return;
      } // Stringify content if object


      if (_typeof(content) === 'object' && content instanceof Blob === false) {
        content = JSON.stringify(content);
      } // Create download link


      var blob = content instanceof Blob ? content : new Blob([content], {
        type: contentType || 'text/plain'
      });
      var link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = "".concat(filename.trim().replace(/["']/g, ''));
      link.style = 'display: none';
      document.body.appendChild(link);
      link.click(); // Remove link from body

      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    }
  }]);

  return HTTP;
}();

exports["default"] = HTTP;
HTTP.uri = 'http://localhost:3000';
HTTP.RequestErrors = _simpleCustomErrors["default"].createError('RequestErrors', [{
  code: 'ResponseError',
  description: 'Error on request',
  params: ['status', 'statusText', 'response', 'request'],
  sentry: false
}, {
  code: 'RequestError',
  description: 'Request error',
  params: ['code', 'errno', 'syscall', 'address', 'port', 'config', 'request']
}]);
HTTP.refreshTokensetPromise = null;